import { render } from "./Reports.vue?vue&type=template&id=5de61169&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"

import "./Reports.vue?vue&type=style&index=0&id=5de61169&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5de61169"

export default script